import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=67f2bd06"
import script from "./CampaignDetails.vue?vue&type=script&lang=ts"
export * from "./CampaignDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports